export interface Session {
  session: number | string;
  orderCollection: string;
  randomClosing: string;
  orderMatching: string;
}

export interface ExistingSession {
  session: string;
  orderCollection: string;
  processingOrder: string;
}

interface Criteria {
  id: number;
  content: string;
}

interface SpecialInfo {
  date: string;
  auction: string;
}

const SESSION_A: Session[] = [
  {
    session: 1,
    orderCollection: '09:00 - 09:55',
    randomClosing: '09:53 - 09:55',
    orderMatching: '09:55 - 10:00',
  },
  {
    session: 2,
    orderCollection: '10:00 - 10:55',
    randomClosing: '10:53 - 10:55',
    orderMatching: '10:55 - 11:00',
  },
  {
    session: 3,
    orderCollection: '11:00 - 11:55',
    randomClosing: '11:53 - 11:55',
    orderMatching: '11:55 - 12:00',
  },
  {
    session: 4,
    orderCollection: '14:00 - 14:55',
    randomClosing: '14:53 - 14:55',
    orderMatching: '14:55 - 15:00',
  },
  {
    session: 5,
    orderCollection: '15:00 - 15:55',
    randomClosing: '15:53 - 15:55',
    orderMatching: '15:55 - 16:00',
  },
];

const SESSION_B: Session[] = [
  {
    session: 1,
    orderCollection: '09:00 - 09:55',
    randomClosing: '09:53 - 09:55',
    orderMatching: '09:55 - 10:00',
  },
  {
    session: 2,
    orderCollection: '10:00 - 11:25',
    randomClosing: '11:23 - 11:25',
    orderMatching: '11:25 - 11:30',
  },
  {
    session: 3,
    orderCollection: '14:00 - 14:55',
    randomClosing: '14:53 - 14:55',
    orderMatching: '14:55 - 15:00',
  },
  {
    session: 4,
    orderCollection: '15:00 - 15:55',
    randomClosing: '15:53 - 15:55',
    orderMatching: '15:55 - 16:00',
  },
];

const CRITERIA: Criteria[] = [
  {
    id: 1,
    content:
      'Harga rata-rata saham selama enam bulan terakhir di pasar reguler kurang dari Rp51. Kriteria ini tidak berlaku untuk perusahaan tercatat yang ada di papan akselerasi.',
  },
  {
    id: 2,
    content:
      'Laporan keuangan auditan terakhir perusahaan terdapat disclaimer. Dengan aturan ini, bursa tidak perlu menunggu perusahaan tercatat mendapat opini disclaimer dua kali, tetapi bursa bisa langsung memasukkan perusahaan ke dalam pemantauan khusus.',
  },
  {
    id: 3,
    content:
      'Memiliki ekuitas negatif pada laporan keuangan terakhir. Pada saat ini, bursa tidak menunggu laporan keuangan tahunan, tapi berdasarkan laporan keuangan interim per Maret, Juni, atau September.',
  },
  {
    id: 4,
    content:
      'Memiliki anak perusahaan yang kontribusi pendapatannya material bagi perusahaan tercatat, dan juga anak perusahaan tersebut dalam kondisi dimohonkan PKPU atau pailit.',
  },
];

const SPECIAL_INFO: SpecialInfo = {
  date: '25 Maret 2024',
  auction: 'Full Call Auction',
};

const SESSION_A_EXISTING: ExistingSession[] = [
  {
    session: 'I',
    orderCollection: '09.00 - 11.55 WIB',
    processingOrder: '11.55 - 12.00 WIB',
  },
  {
    session: 'II',
    orderCollection: '13.25 - 15.55 WIB',
    processingOrder: '15.55 - 16.00 WIB',
  },
];

const SESSION_B_EXISTING: ExistingSession[] = [
  {
    session: 'I',
    orderCollection: '09.00 - 11.25 WIB',
    processingOrder: '11.25 - 11.30 WIB',
  },
  {
    session: 'II',
    orderCollection: '13.55 - 15.55 WIB',
    processingOrder: '15.55 - 16.00 WIB',
  },
];

const SPECIAL_INFO_EXISTING: SpecialInfo = {
  date: '12 Juni 2023',
  auction: 'Hybrid Call Auction',
};

const FULL_CALL_AUCTION = [
  {
    label: 'Input Order',
    inclusion: [true, false, false],
  },
  {
    label: 'Amend',
    inclusion: [true, false, false],
  },
  {
    label: 'Withdraw',
    inclusion: [true, false, true],
  },
];

export const EXISTING_CONTENT = {
  SESSION_A: SESSION_A_EXISTING,
  SESSION_B: SESSION_B_EXISTING,
  CRITERIA,
  SPECIAL_INFO: SPECIAL_INFO_EXISTING,
  FULL_CALL_AUCTION,
};

export default {
  SESSION_A,
  SESSION_B,
  CRITERIA,
  SPECIAL_INFO,
  FULL_CALL_AUCTION,
};
